import type { PaginationInput } from './query-keys';

const DEFAULT_PAGE_SIZE = 10;

type P = {
  defaultPageSize?: number;
  pagination?: PaginationInput;
};

export const getPaginationSkip = ({ defaultPageSize = DEFAULT_PAGE_SIZE, pagination }: P) => {
  const pageSize = pagination?.pageSize ?? defaultPageSize;

  const skip =
    pagination?.type === 'offset'
      ? (pagination.offset ?? 0)
      : Math.max(0, ((pagination?.position ?? 1) - 1) * pageSize);

  return { pageSize, skip };
};
